import {Container, Grid, MenuItem, TableBody, TableHead, TextField} from "@mui/material";
import React, {useEffect, useState} from "react";
import {
    StyledButtonBlack,
    StyledButtonContainer, StyledButtonOrange,
    StyledTable,
    StyledTableBodyRow, StyledTableCell,
    StyledTableCellHeader,
    StyledTableHeadRow
} from "../../../styles/MyStyles";
import dayjs from "dayjs";
import {GetEnumMenuItems, GetEnumValueName} from "../../../logic/EnumHelper";
import {useNavigate} from "react-router-dom";
import {GetCookieInfo} from "../../../logic/CookieManager";
import {GetClientViewName} from "../../../logic/ClientNameHelper";
import {GetClients} from "../../../logic/DataProvider";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread';
import {UpdateNotificationState} from "../../../logic/NotificationsHelper";

const NotificationsPage = () => {
    const navigate = useNavigate();
    const [clients, setClients] = useState([]);
    const [notifications, setNotifications] = useState([]);

    const [selectedClient, setSelectedClient] = useState('');
    const [selectedType, setSelectedType] = useState('');
    const [selectedState, setSelectedState] = useState('');

    useEffect(() => {
        GetClients().then((clients) => setClients(clients));
        const fetchNotifications = async () => {
            try {
                const tokenCookie = GetCookieInfo('nplt');
                const response = await fetch(`${process.env.REACT_APP_NOTIFICATIONS_URL}/get`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                    body: JSON.stringify({
                        //connectedContactId: notificationId,
                        //state: 1,
                        //type: 1
                    })
                });
                if (response.ok) {
                    const data = await response.json();

                    data.data.sort((a, b) => {
                        const dateA = new Date(a.date);
                        const dateB = new Date(b.date);
                        return dateB - dateA;
                    });

                    data.data.forEach((elem) => {
                        elem.metaObj = JSON.parse(elem.meta);
                    });

                    setNotifications(data.data);
                } else {
                    console.log('Fetch notifications failed.');
                }
            } catch (error) {
                console.log('An error occurred:', error);
            }
        };
        fetchNotifications();
    }, []);

    const rowClick = (notification) => {
        navigate(`/tickets/${notification.metaObj.Id}`);
    }

    const getClientsMenuItems = () => {
        let items = [<MenuItem key="" value="">All</MenuItem>];
        if (clients) {
            clients.forEach((elem) => {
                items.push(
                    <MenuItem key={elem.id} value={elem.id}>
                        {GetClientViewName(elem)}
                    </MenuItem>
                );
            });
        }
        return items;
    };

    const handleClientFilter = (event) => {
        setSelectedClient(event.target.value);
    };

    const handleTypeFilter = (event) => {
        setSelectedType(event.target.value);
    };

    const handleStateFilter = (event) => {
        setSelectedState(event.target.value);
    };

    const filteredNotifications = notifications ? notifications.filter(
        (item) => (selectedClient === '' || item.connectedContactId === parseInt(selectedClient))
                && (selectedType === '' || item.type === parseInt(selectedType))
                && (selectedState === '' || item.state === parseInt(selectedState))
        ) : [];

    const handleGoBack = () => {
        navigate('/');
    };

    const updateNotificationState = async (e, notificationId, newState) => {
        e.stopPropagation();
        let success = await UpdateNotificationState(notificationId, newState);

        if (success) {
            var newArr = [];

            notifications.forEach((elem) => {
                if (elem.id === notificationId) {
                    elem.state = newState;
                }
                newArr.push(elem);
            });

            setNotifications(newArr);
        }
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                    <TextField
                        select
                        label="Client"
                        value={selectedClient}
                        onChange={handleClientFilter}
                        margin="normal"
                        size="small"
                        fullWidth
                    >
                        {getClientsMenuItems()}
                    </TextField>
                </Grid>
                <Grid item xs={12} md={3}>
                    <TextField
                        select
                        label="Type"
                        value={selectedType}
                        onChange={handleTypeFilter}
                        margin="normal"
                        size="small"
                        fullWidth
                    >
                        {GetEnumMenuItems('internalNotificationType', true)}
                    </TextField>
                </Grid>
                <Grid item xs={12} md={3}>
                    <TextField
                        select
                        label="State"
                        value={selectedState}
                        onChange={handleStateFilter}
                        margin="normal"
                        size="small"
                        fullWidth
                    >
                        {GetEnumMenuItems('internalNotificationState', true)}
                    </TextField>
                </Grid>
                <Grid item xs={12} md={3} sx={{ textAlign: 'right' }}>
                    <StyledButtonContainer>
                        <StyledButtonOrange variant="contained" onClick={handleGoBack} margin="normal">
                            Back to dashboard
                        </StyledButtonOrange>
                    </StyledButtonContainer>
                </Grid>
                <Grid item xs={12}>
                    <StyledTable>
                        <TableHead>
                            <StyledTableHeadRow>
                                <StyledTableCellHeader columncount={5}>Date</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={5}>Connected Contact</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={5}>Type</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={5}>State</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={5}></StyledTableCellHeader>
                            </StyledTableHeadRow>
                        </TableHead>
                        <TableBody>
                            {filteredNotifications && filteredNotifications.map((item) => (
                                <StyledTableBodyRow key={item.id} onClick={() => rowClick(item)}>
                                    <StyledTableCell>{dayjs(item.date).toDate().toDateString()}</StyledTableCell>
                                    <StyledTableCell>{GetClientViewName(clients.find(e => e.id === item.connectedContactId))}</StyledTableCell>
                                    <StyledTableCell>{GetEnumValueName('internalNotificationType', item.type)}</StyledTableCell>
                                    <StyledTableCell>{GetEnumValueName('internalNotificationState', item.state)}</StyledTableCell>
                                    {item.state === 0 && (
                                        <StyledTableCell>
                                            <StyledButtonOrange variant="contained" component="span"
                                                                onClick={(e) => updateNotificationState(e, item.id, 1)}>
                                                <MarkEmailReadIcon/>
                                            </StyledButtonOrange>
                                        </StyledTableCell>
                                    )}
                                    {item.state === 1 && (
                                        <StyledTableCell>
                                            <StyledButtonBlack variant="contained" component="span"
                                                                onClick={(e) => updateNotificationState(e, item.id, 0)}>
                                                <MarkEmailUnreadIcon/>
                                            </StyledButtonBlack>
                                        </StyledTableCell>
                                    )}
                                </StyledTableBodyRow>
                            ))}
                        </TableBody>
                    </StyledTable>
                </Grid>
            </Grid>
        </Container>
    );
};

export default NotificationsPage;